import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

interface SequentialAnimationProps {
  children: React.ReactNode;
  initialDelay?: number;
}

export const SequentialAnimation: React.FC<SequentialAnimationProps> = ({
  children,
  initialDelay = 0,
}) => {
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await new Promise((resolve) => setTimeout(resolve, initialDelay * 1000));
      controls.start("visible");
    };
    sequence();
  }, [controls, initialDelay]);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
      },
    }),
  };

  return (
    <>
      {React.Children.map(children, (child, i) => {
        if (!React.isValidElement(child)) return null;
        return (
          <motion.div
            key={i}
            custom={i}
            initial="hidden"
            animate={controls}
            variants={containerVariants}
            className="overflow-visible"
          >
            {child}
          </motion.div>
        );
      })}
    </>
  );
};
